import { apiSlice } from "../api/apiSlice";

export const videosApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => `/videos?sort=timestamp&_order=desc`,
    }),
    getVideo: builder.query({
      query: (id) => `/videos/${id}`,
    }),
    addVideo: builder.mutation({
      query: ({ data }) => ({
        url: "/videos",
        method: "POST",
        body: data,
      }),
      onSuccess: (data) => {
        console.log("Video added successfully: ", data);
      },
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const video = await queryFulfilled;

          if (video?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                // Update the relevant task in the tasks array
                draft.push(video?.data);

                return draft;
              })
            );
          }
        } catch {}
      },
    }),
    editVideo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const video = await queryFulfilled;

          if (video?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                // Update the relevant task in the tasks array
                const videoIndex = JSON.stringify(
                  // eslint-disable-next-line
                  draft.findIndex((video) => video.id == arg?.id)
                );

                Object.assign(draft[videoIndex], video?.data);

                return draft;
              })
            );
          }
        } catch {}
      },
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
            // Update the relevant task in the tasks array
            // eslint-disable-next-line
            const videoIndex = JSON.stringify(
              // eslint-disable-next-line
              draft.findIndex((video) => video.id == arg)
            );

            // eslint-disable-next-line
            return draft.filter((video) => video.id != arg);
          })
        );
        // optimistic cache update end
        try {
          await queryFulfilled;
        } catch {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetVideosQuery,
  useGetVideoQuery,
  useAddVideoMutation,
  useEditVideoMutation,
  useDeleteVideoMutation,
} = videosApi;
